// ===================== SESSION IDS =============================
export const SESSION_ID_CHANGE_SERVICE_KEYS = "SESSION_ID_CHANGE_SERVICE_KEYS";
export const SESSION_ID_SINGLE_ID_CHANGE = "SESSION_ID_SINGLE_ID_CHANGE";
export const SESSION_ID_SINGLE_PRODUCT_RESET =
  "SESSION_ID_SINGLE_PRODUCT_RESET";
export const SESSION_ID_RESET_ALL = "SESSION_ID_RESET_ALL";

// ================ PRICE SEARCH FORM SEARCH =====================
export const PRICE_SEARCH_FORM_CHANGE = "PRICE_SEARCH_FORM_CHANGE";
export const PRICE_SEARCH_FORM_SEARCHING = "PRICE_SEARCH_FORM_SEARCHING";
export const PRICE_SEARCH_FORM_IDLE = "PRICE_SEARCH_FORM_IDLE";

// ============================== ADDONS =============================

export const TOUR_PRICE_INFO_SAVE = "TOUR_PRICE_INFO_SAVE";
export const TOUR_PRICE_INFO_LOAD_STATE = "TOUR_PRICE_INFO_LOAD_STATE";
export const TOUR_PRICE_INFO_RESET = "TOUR_PRICE_INFO_RESET";
export const TOUR_PRICE_INFO_SEARCH_SESSION_INFO_SAVE =
  "TOUR_PRICE_INFO_SEARCH_SESSION_INFO_SAVE";

export const TOURS_METADATA_SAVE = "TOURS_DESTINATIONS_SAVE";

export const TOUR_SEARCH_FORM_CHANGE = "TOUR_SEARCH_FORM_CHANGE";
export const TOUR_SEARCH_FORM_UPDATE = "TOUR_SEARCH_FORM_UPDATE";
export const TOUR_SEARCH_FORM_RESET = "TOUR_SEARCH_FORM_RESET";

export const TOURS_LIST_SAVE = "TOURS_LIST_SAVE";
export const TOURS_LIST_LOADING = "TOURS_LIST_LOADING";
export const TOURS_LIST_IDLE = "TOURS_LIST_IDLE";
export const TOUR_INIT_SEARCH_DATA_SAVE = "TOUR_INIT_SEARCH_DATA_SAVE";
export const TOUR_SEARCH_DATA_SAVE = "TOUR_SEARCH_DATA_SAVE";
export const TOUR_SEARCH_INIT_SEARCH_STATUSES =
  "TOUR_SEARCH_INIT_SEARCH_STATUSES";

// ============================== TOURS ==============================

export const TOURS_LIST_SET_PRODUCT_TYPE = "TOURS_LIST_SET_PRODUCT_TYPE";

// ============================= PACKAGES ============================
export const PACKAGES_METADATA_SAVE = "PACKAGES_DESTINATIONS_SAVE";

// ==================== PACKAGES & TOURS FILTERING ===================
export const LIST_ORDER_CHANGE = "LIST_ORDER_CHANGE";

// ====================== PACKAGE DETAILS SEARCH =====================
export const PACKAGE_ACC_POLL_SAVE = "PACKAGE_ACC_POLL_SAVE";
export const PACKAGE_FLIGHT_SEARCH_RESULT_SAVE =
  "PACKAGE_FLIGHT_SEARCH_RESULT_SAVE";
export const PACKAGE_TRF_SEARCH_RESULT_SAVE = "PACKAGE_TRF_SEARCH_RESULT_SAVE";
export const PACKAGE_SERVICE_SET_SEARCH_STATUS =
  "PACKAGE_SERVICE_SET_UPDATED_STATUS";
// ======================== FLIGHT SEARCH FORM =======================
export const FLIGHT_SEARCH_FORM_UPDATE = "FLIGHT_SEARCH_FORM_UPDATE";
// ======================= SINGLE FLIGHT SEARCH ======================
export const SINGLE_FLIGHT_SEARCH_RESET = "SINGLE_FLIGHT_SEARCH_RESET";
export const SINGLE_FLIGHT_SEARCH_INIT = "SINGLE_FLIGHT_SEARCH_INIT";
export const SINGLE_FLIGHT_SEARCH_CHANGE = "SINGLE_FLIGHT_SEARCH_CHANGE";
export const SINGLE_FLIGHT_SEARCH_LOADING = "SINGLE_FLIGHT_SEARCH_LOADING";
export const SINGLE_FLIGHT_SEARCH_IDLE = "SINGLE_FLIGHT_SEARCH_IDLE";
export const SINGLE_FLIGHT_SEARCH_UPDATE = "SINGLE_FLIGHT_SEARCH_UPDATE";
export const SINGLE_FLIGHT_SEARCH_SET_PAYLOAD =
  "SINGLE_FLIGHT_SEARCH_SET_PAYLOAD";
export const SINGLE_FLIGHT_FILTER_RESET_SINGLE =
  "SINGLE_FLIGHT_FILTER_RESET_SINGLE";
export const SINGLE_FLIGHT_FILTER_CHANGE = "SINGLE_FLIGHT_FILTER_CHANGE";

// ========================== FLIGHT FILTERS =========================
export const FLIGHT_SEARCH_FILTER_UPDATE = "FLIGHT_SEARCH_FILTER_UPDATE";

// ====================== RESTAURANT FILTERS =========================
export const RESTAURANT_SEARCH_LOADING = "RESTAURANT_SEARCH_LOADING";
export const RESTAURANT_SEARCH_IDLE = "RESTAURANT_SEARCH_IDLE";
export const RESTAURANT_SEARCH_CHANGE = "RESTAURANT_SEARCH_CHANGE";
export const RESTAURANT_SEARCH_UPDATE = "RESTAURANT_SEARCH_UPDATE";
export const RESTAURANT_SEARCH_FORM_UPDATE = "RESTAURANT_SEARCH_FORM_UPDATE";
export const RESTAURANT_SEARCH_RESET = "RESTAURANT_SEARCH_RESET";
export const RESTAURANT_CATEGORIES_SAVE = "RESTAURANT_CATEGORIES_SAVE";
export const RESTAURANT_SEARCH_FORM_INIT = "RESTAURANT_SEARCH_FORM_INIT";

// ====================== ACTIVITY SEARCH ============================
export const ACTIVITY_SEARCH_FORM_UPDATE = "ACTIVITY_SEARCH_FORM_UPDATE";
export const ACTIVITY_SEARCH_FORM_INIT = "ACTIVITY_SEARCH_FORM_INIT";
export const SINGLE_ACTIVITY_SEARCH_LOADING = "SINGLE_ACTIVITY_SEARCH_LOADING";
export const SINGLE_ACTIVITY_SEARCH_IDLE = "SINGLE_ACTIVITY_SEARCH_IDLE";
export const SINGLE_ACTIVITY_SEARCH_CHANGE = "SINGLE_ACTIVITY_SEARCH_CHANGE";
export const SINGLE_ACTIVITY_SEARCH_UPDATE = "SINGLE_ACTIVITY_SEARCH_UPDATE";
export const SINGLE_ACTIVITY_SEARCH_RESET = "SINGLE_ACTIVITY_SEARCH_RESET";

// ====================== ACTIVITY SELECTED ==========================
export const SINGLE_ACTIVITY_SELECTED_LOADING =
  "SINGLE_ACTIVITY_SELECTED_LOADING";
export const SINGLE_ACTIVITY_SELECTED_IDLE = "SINGLE_ACTIVITY_SELECTED_IDLE";
export const SINGLE_ACTIVITY_SELECTED_CHANGE =
  "SINGLE_ACTIVITY_SELECTED_CHANGE";
export const SINGLE_ACTIVITY_SELECTED_UPDATE =
  "SINGLE_ACTIVITY_SELECTED_UPDATE";
export const SINGLE_ACTIVITY_SELECTED_RESET = "SINGLE_ACTIVITY_SELECTED_RESET";

// ====================== ACTIVITY FILTERS ===========================
export const ACTIVITY_SEARCH_FILTERS_INIT = "ACTIVITY_SEARCH_FILTERS_INIT";
export const ACTIVITY_SEARCH_FILTERS_CHANGE = "ACTIVITY_SEARCH_FILTERS_CHANGE";
export const ACTIVITY_SEARCH_FILTERS_UPDATE = "ACTIVITY_SEARCH_FILTERS_UPDATE";

// =================== TRANSFER SEARCH FORM ==========================
export const TRANSFER_SEARCH_FORM_UPDATE = "TRANSFER_SEARCH_FORM_UPDATE";
export const TRANSFER_SEARCH_FORM_CHANGE = "TRANSFER_SEARCH_FORM_CHANGE";
export const TRANSFER_SEARCH_FORM_RESET = "TRANSFER_SEARCH_FORM_RESET";

// ================= TRANSFER SEARCH RESULTS =========================
export const TRANSFER_SEARCH_RESULTS_LOADING =
  "TRANSFER_SEARCH_RESULTS_LOADING";
export const TRANSFER_SEARCH_RESULTS_IDLE = "TRANSFER_SEARCH_RESULTS_IDLE";
export const TRANSFER_SEARCH_RESULTS_CHANGE = "TRANSFER_SEARCH_RESULTS_CHANGE";
export const TRANSFER_SEARCH_RESULTS_UPDATE = "TRANSFER_SEARCH_RESULTS_UPDATE";
export const TRANSFER_SEARCH_RESULTS_RESET = "TRANSFER_SEARCH_RESULTS_RESET";

// ===================== TRANSFER FILTERS =======================
export const TRANSFER_FILTERS_INIT = "TRANSFER_FILTERS_INIT";
export const TRANSFER_FILTERS_CHANGE = "TRANSFER_FILTERS_CHANGE";
export const TRANSFER_FILTERS_UPDATE = "TRANSFER_FILTERS_UPDATE";
export const TRANSFER_SINGLE_FILTER_INIT = "TRANSFER_SINGLE_FILTER_INIT";

// =============== SINGLE TRANSFER FILTERS =======================
export const SELECTED_TRANSFER_LOADING = "SELECTED_TRANSFER_LOADING";
export const SELECTED_TRANSFER_IDLE = "SELECTED_TRANSFER_IDLE";
export const SELECTED_TRANSFER_CHANGE = "SELECTED_TRANSFER_CHANGE";
export const SELECTED_TRANSFER_UPDATE = "SELECTED_TRANSFER_UPDATE";
export const SELECTED_TRANSFER_RESET = "SELECTED_TRANSFER_RESET";

// ================ CAR RENTAL SEARCH FORM =======================
export const CAR_RENTAL_SEARCH_FORM_UPDATE = "CAR_RENTAL_SEARCH_FORM_UPDATE";
export const CAR_RENTAL_SEARCH_FORM_CHANGE = "CAR_RENTAL_SEARCH_FORM_CHANGE";
export const CAR_RENTAL_SEARCH_FORM_RESET = "CAR_RENTAL_SEARCH_FORM_RESET";

// =============== CAR RENTAL SEARCH RESULTS =====================
export const CAR_RENTAL_SEARCH_RESULTS_LOADING =
  "CAR_RENTAL_SEARCH_RESULTS_LOADING";
export const CAR_RENTAL_SEARCH_RESULTS_IDLE = "CAR_RENTAL_SEARCH_RESULTS_IDLE";
export const CAR_RENTAL_SEARCH_RESULTS_CHANGE =
  "CAR_RENTAL_SEARCH_RESULTS_CHANGE";
export const CAR_RENTAL_SEARCH_RESULTS_UPDATE =
  "CAR_RENTAL_SEARCH_RESULTS_UPDATE";
export const CAR_RENTAL_SEARCH_RESULTS_RESET =
  "CAR_RENTAL_SEARCH_RESULTS_RESET";

// ============== SINGLE CAR RENTAL FILTERS ======================
export const CAR_RENTAL_FILTERS_RESET = "CAR_RENTAL_FILTERS_RESET";
export const CAR_RENTAL_SINGLE_FILTER_RESET = "CAR_RENTAL_SINGLE_FILTER_RESET";
export const CAR_RENTAL_FILTERS_CHANGE = "CAR_RENTAL_FILTERS_CHANGE";
export const CAR_RENTAL_FILTERS_UPDATE = "CAR_RENTAL_FILTERS_UPDATE";

// ================= SELECTED CAR RENTAL  ========================
export const SELECTED_CAR_RENTAL_LOADING = "SELECTED_CAR_RENTAL_LOADING";
export const SELECTED_CAR_RENTAL_IDLE = "SELECTED_CAR_RENTAL_IDLE";
export const SELECTED_CAR_RENTAL_CHANGE = "SELECTED_CAR_RENTAL_CHANGE";
export const SELECTED_CAR_RENTAL_UPDATE = "SELECTED_CAR_RENTAL_UPDATE";
export const SELECTED_CAR_RENTAL_RESET = "SELECTED_CAR_RENTAL_RESET";

// ================= TRAIN SEARCH FORM ===========================
export const TRAIN_SEARCH_FORM_UPDATE = "TRAIN_SEARCH_FORM_UPDATE";
export const TRAIN_SEARCH_FORM_CHANGE = "TRAIN_SEARCH_FORM_CHANGE";
export const TRAIN_SEARCH_FORM_RESET = "TRAIN_SEARCH_FORM_RESET";

// ==================== TRAIN FILTERS ============================
export const TRAIN_FILTERS_RESET = "TRAIN_FILTERS_RESET";
export const TRAIN_SINGLE_FILTER_RESET = "TRAIN_SINGLE_FILTER_RESET";
export const TRAIN_FILTERS_CHANGE = "TRAIN_FILTERS_CHANGE";
export const TRAIN_FILTERS_UPDATE = "TRAIN_FILTERS_UPDATE";

// ================= TRAIN SEARCH RESULTS ========================
export const TRAIN_SEARCH_RESULTS_LOADING = "TRAIN_SEARCH_RESULTS_LOADING";
export const TRAIN_SEARCH_RESULTS_IDLE = "TRAIN_SEARCH_RESULTS_IDLE";
export const TRAIN_SEARCH_RESULTS_CHANGE = "TRAIN_SEARCH_RESULTS_CHANGE";
export const TRAIN_SEARCH_RESULTS_UPDATE = "TRAIN_SEARCH_RESULTS_UPDATE";
export const TRAIN_SEARCH_RESULTS_RESET = "TRAIN_SEARCH_RESULTS_RESET";

// ================= FERRY SEARCH FORM ===========================
export const FERRY_SEARCH_FORM_UPDATE = "FERRY_SEARCH_FORM_UPDATE";
export const FERRY_SEARCH_FORM_CHANGE = "FERRY_SEARCH_FORM_CHANGE";
export const FERRY_SEARCH_FORM_RESET = "FERRY_SEARCH_FORM_RESET";

// ================= FERRY SEARCH RESULTS ========================
export const FERRY_SEARCH_RESULTS_LOADING = "FERRY_SEARCH_RESULTS_LOADING";
export const FERRY_SEARCH_RESULTS_IDLE = "FERRY_SEARCH_RESULTS_IDLE";
export const FERRY_SEARCH_RESULTS_CHANGE = "FERRY_SEARCH_RESULTS_CHANGE";
export const FERRY_SEARCH_RESULTS_UPDATE = "FERRY_SEARCH_RESULTS_UPDATE";
export const FERRY_SEARCH_RESULTS_RESET = "FERRY_SEARCH_RESULTS_RESET";

// ==================== FERRY FILTERS ============================
export const FERRY_FILTERS_RESET = "FERRY_FILTERS_RESET";
export const FERRY_SINGLE_FILTER_RESET = "FERRY_SINGLE_FILTER_RESET";
export const FERRY_FILTERS_CHANGE = "FERRY_FILTERS_CHANGE";
export const FERRY_FILTERS_UPDATE = "FERRY_FILTERS_UPDATE";

// ================== SINGLE FERRY FILTERS =======================
export const SELECTED_FERRY_LOADING = "SELECTED_FERRY_LOADING";
export const SELECTED_FERRY_IDLE = "SELECTED_FERRY_IDLE";
export const SELECTED_FERRY_CHANGE = "SELECTED_FERRY_CHANGE";
export const SELECTED_FERRY_UPDATE = "SELECTED_FERRY_UPDATE";
export const SELECTED_FERRY_RESET = "SELECTED_FERRY_RESET";
